import { render, staticRenderFns } from "./SharingStep.vue?vue&type=template&id=df4c54fa&scoped=true"
import script from "./SharingStep.vue?vue&type=script&lang=js"
export * from "./SharingStep.vue?vue&type=script&lang=js"
import style0 from "./SharingStep.vue?vue&type=style&index=0&id=df4c54fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4c54fa",
  null
  
)

export default component.exports